import { EarnDirectDetailsSummary } from '../../components/direct/EarnDirectDetailsSummary'
import { EarnDetailsLayout } from '../../components/EarnDetailsLayout'
import { useEarnDirectDetailsData } from '../../hooks/details/useEarnDirectDetailsData'
import { EARN_DETAILS_STATE, UseEarnDetailsDataHandlers } from '../../types/detailsState'

export interface EarnDirectDetailsViewProps extends UseEarnDetailsDataHandlers {
  portfolioId: string | undefined
}

export const EarnDirectDetailsView = ({
  portfolioId,
  onDeposit,
  onWithdraw,
}: EarnDirectDetailsViewProps) => {
  const viewData = useEarnDirectDetailsData(portfolioId, { onDeposit, onWithdraw })

  return (
    <EarnDetailsLayout portfolioId={portfolioId} viewData={viewData}>
      {viewData.detailsState === EARN_DETAILS_STATE.READY && (
        <EarnDirectDetailsSummary
          earnRate={viewData.earnRate}
          allocatedFunds={viewData.summary.allocatedFunds}
          myLifetimeEarnings={viewData.myLifetimeEarnings}
          unallocatedFunds={viewData.summary.unallocatedFunds}
          isStatisticsLoading={viewData.isStatisticsLoading}
        />
      )}
    </EarnDetailsLayout>
  )
}
